/*
 *
 *  UI Store
 */

// deps
import store from '@/store/s.index'

// state
const state = {
  webpSupport: false,
  navItems: [
    {
      key: 'home',
      order: 10,
      title: 'الرئيسية',
      path: {
        name: 'Home'
      },
      views: ['extra', 'global'],
      icon: 'mdi-home',
      forceIcon: true
    },
    {
      key: 'contact',
      order: 11,
      title: 'تواصل معنا',
      path: {
        name: 'Contact'
      },
      views: ['extra', 'global'],
      icon: 'mdi-phone',
      forceIcon: true,
      divider: true
    },
    // {
    //   key: 'team',
    //   order: 60,
    //   title: 'فريقنا',
    //   path: { name: 'Team' },
    //   views: ['extra', 'global'],
    //   icon: 'mdi-account-group',
    //   divider: true
    // },
    {
      key: 'twitter',
      order: 81,
      title: 'تابعنا على تويتر',
      link: 'https://twitter.com/senses_sa',
      views: ['extra'],
      icon: 'mdi-twitter',
      color: '#38A1F3'
    },
    {
      key: 'instagram',
      order: 82,
      title: 'تابعنا على انستقرام',
      link: 'https://www.instagram.com/senses_sa/',
      views: ['extra'],
      icon: 'mdi-instagram',
      color: '#C13584'
    },
    {
      key: 'map',
      order: 83,
      title: 'موقعنا على الخريطة',
      link: 'https://goo.gl/maps/jgScs58yXK6ykZiJA',
      views: ['extra'],
      icon: 'mdi-map-marker',
      color: 'info'
    }
  ],
  drawerStatus: false
}

// getters
const getters = {
  hasWebpSupport: state => state.webpSupport,
  getNav: state => views => {
    // clone main items
    const items = state.navItems.slice(0)
    // get services data
    const servicesData = Object.assign({}, store.getters.getServices)
    // loop services
    const keys = Object.keys(servicesData)
    keys.forEach((key, index) => {
      const serviceData = servicesData[key]
      const item = {
        key: serviceData.key,
        order: serviceData.nav.order,
        subheader: serviceData.nav.subheader,
        title: serviceData.name,
        subtitle: serviceData.altName,
        path: serviceData.path,
        views: serviceData.nav.views,
        icon: serviceData.icon,
        divider: index === keys.length - 1
      }
      items.push(item)
    })
    // init items
    const navItems = []
    // loop items
    items.forEach(item => {
      /*
       * Validate what to show
       */
      // init valid
      var valid = false
      // handle views
      views.forEach(view => {
        if (item.views.includes(view)) {
          valid = true
        }
      })
      // add to menu when valid
      if (valid) navItems.push(item)
    })
    // check items to disable menu
    if (navItems.length < 1) return false
    // order
    navItems.sort((a, b) => (a.order > b.order ? 1 : -1))
    // return
    return navItems
  },
  getNavItems: state => {
    return state.navItems
  },
  getDrawerStatus: state => {
    return state.drawerStatus
  }
}

// actions
const actions = {
  async checkWebpSupport({ commit }) {
    // If the browser doesn't has the method createImageBitmap, you can't display webp format
    if (!self.createImageBitmap) return false
    // Base64 representation of a white point image
    const webpData = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA='
    // Retrieve the Image in Blob Format
    const blob = await fetch(webpData).then(r => r.blob())
    // If the createImageBitmap method succeeds, return true, otherwise false
    return createImageBitmap(blob).then(
      () => {
        commit('setWebpSupport', true)
        return true
      },
      () => {
        commit('setWebpSupport', false)
        return false
      }
    )
  }
}

// mutations
const mutations = {
  setWebpSupport(state, status) {
    state.webpSupport = status
  },
  setDrawerStatus(state, status) {
    state.drawerStatus = status
  }
}

// export
export default {
  state,
  getters,
  actions,
  mutations
}
